export enum ProductTypeEnum {
  SIMPLE_PRODUCT = 'SimpleProduct',
  BUNDLE_PRODUCT = 'BundleProduct'
}
